import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FactFinderHome from '../components/factFinder/FactFinderHome';
import InvestigationModePage from '../components/factFinder/InvestigationModePage';
import QuickLogPage from '../components/factFinder/QuickLogPage';
import FullRecordPage from '../components/factFinder/FullRecordPage';
import analyticsTracker from '../utils/analyticsTracker';
// Styles consolidated into index.css

function FactFinderV2Page({ user }) {
  const [mode, setMode] = useState(null);
  const [loadedCase, setLoadedCase] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    analyticsTracker.trackPageView('fact_finder');
  }, []);

  function handleOpenCase(caseItem) {
    const caseMode = caseItem?.case_payload?.mode || caseItem?.mode || 'investigation';
    setLoadedCase(caseItem);
    if (caseMode === 'quick_log') {
      setMode('full-record');
    } else if (caseMode === 'full_record') {
      setMode('full-record');
    } else {
      setMode('investigation');
    }
  }

  function handleExpandToInvestigation(caseItem) {
    setLoadedCase(caseItem);
    setMode('investigation');
  }

  function handleExpandToFullRecord(caseItem) {
    setLoadedCase(caseItem);
    setMode('full-record');
  }

  function goHome() {
    setMode(null);
    setLoadedCase(null);
  }

  if (!mode) {
    return <FactFinderHome onSelectMode={(m) => {
      if (m === 'grievance-prep') {
        navigate('/grievance-builder');
        return;
      }
      if (m === 'full-record') {
        navigate('/fact-finder/form');
        return;
      }
      analyticsTracker.trackFactFinderStarted(m);
      setMode(m);
    }} onOpenCase={handleOpenCase} />;
  }

  if (mode === 'investigation') {
    return (
      <InvestigationModePage
        user={user}
        onBack={goHome}
        loadedCase={loadedCase}
      />
    );
  }

  if (mode === 'quick-log') {
    return (
      <QuickLogPage
        user={user}
        onBack={goHome}
        onOpenInvestigation={handleExpandToInvestigation}
        onExpandFullRecord={handleExpandToFullRecord}
      />
    );
  }

  if (mode === 'full-record') {
    return (
      <FullRecordPage
        user={user}
        onBack={goHome}
        loadedCase={loadedCase}
        onOpenInvestigation={handleExpandToInvestigation}
      />
    );
  }

  return null;
}

export default FactFinderV2Page;
